module.exports = __webpack_public_path__ + "static/media/chorthippus_pullus_001_APA.94b86cd0.mp3";